/**
 * @flow
 * @relayHash 1b60da219556579c7a97a96a16b83c64
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type QuotationSupplierUpdateInput = {|
  id: string,
  num: string,
  title: string,
  description?: ?string,
  address: string,
  date: any,
  tax?: ?string,
  discountType?: ?string,
  discountValue?: ?string,
  total: string,
  totalTTC: string,
  currencyId: string,
  supplierId: string,
  quotationSupplierItem: $ReadOnlyArray<QuotationSupplierItemCreateInput>,
|};
export type QuotationSupplierItemCreateInput = {|
  designation: string,
  description?: ?string,
  quantity: string,
  unityId: string,
  discount?: ?string,
  unitPrice: string,
  total: string,
|};
export type UpdateQuotationSupplierMutationVariables = {|
  data: QuotationSupplierUpdateInput
|};
export type UpdateQuotationSupplierMutationResponse = {|
  +updateQuotationSupplier: {|
    +id: string
  |}
|};
export type UpdateQuotationSupplierMutation = {|
  variables: UpdateQuotationSupplierMutationVariables,
  response: UpdateQuotationSupplierMutationResponse,
|};
*/


/*
mutation UpdateQuotationSupplierMutation(
  $data: QuotationSupplierUpdateInput!
) {
  updateQuotationSupplier(data: $data) {
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "data",
    "type": "QuotationSupplierUpdateInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "updateQuotationSupplier",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "data",
        "variableName": "data"
      }
    ],
    "concreteType": "QuotationSupplierModel",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "UpdateQuotationSupplierMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "UpdateQuotationSupplierMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "UpdateQuotationSupplierMutation",
    "id": null,
    "text": "mutation UpdateQuotationSupplierMutation(\n  $data: QuotationSupplierUpdateInput!\n) {\n  updateQuotationSupplier(data: $data) {\n    id\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '004f5ed5bda7b79626346217a4beb3b5';
module.exports = node;
